import { useCallback } from 'react'

import { RuleType } from '@cox/core-ui8/dist/types'

import { ORIGIN } from '../../../constants'
import RuleDetails from '../RuleBuilder/RuleDetails'
import RuleResultsRenderer from '../RuleBuilder/RuleResultsRenderer'
import RuleTypeRenderer from '../RuleBuilder/RuleTypeRenderer'

const RuleBuilderConditional = (props: any) => {
  const {
    conditionals = [],
    id,
    isInEditor = false,
    editmode = false,
    ruleExpression,
    index,
    resultsTrue,
    resultsFalse,
    ruleId,
    componentTypeRenderer
  } = props
  const isEditor = isInEditor || editmode || ORIGIN.includes('author')
  const defaultblock = conditionals.find((condition: any) => condition.defaultblock)
  const filteredCondtionals = conditionals.filter((condition: any) => !condition.defaultblock)

  const getConditionals = useCallback(() => {
    if (isEditor) {
      return conditionals.map((condition: any, conditionIndex: number) => {
        const {
          ruleExpression,
          resultsTrue = {},
          ruleId,
          ruleType,
          ruleName,
          ruleDescription,
          trueExpFragmentPath,
          falseExpFragmentPath
        } = condition

        return (
          <div key={conditionIndex}>
            <RuleDetails
              isInEditor={isEditor}
              ruleId={ruleId}
              ruleType={ruleType}
              ruleName={ruleName}
              ruleDescription={ruleDescription}
              ruleExpression={ruleExpression}
              trueExpFragmentPath={trueExpFragmentPath}
              falseExpFragmentPath={falseExpFragmentPath}
            />
            <RuleTypeRenderer
              ruleId={ruleId}
              resultsTrue={resultsTrue}
              resultsFalse={resultsFalse}
              ruleType={ruleType}
              condition={condition}
              ruleExpression={ruleExpression}
              isInEditor={isEditor}
              componentTypeRenderer={componentTypeRenderer}
              compName={props?.compName}
            />
          </div>
        )
      })
    } else {
      let result
      for (const condition of filteredCondtionals) {
        const { ruleExpression, resultsTrue = {}, ruleId, ruleType } = condition

        const getUdoResult = () => {
          if (typeof ruleExpression === 'string') {
            return (
              ruleType === RuleType.udoconditional &&
              ruleExpression &&
              !ruleExpression?.includes('udo') &&
              eval(ruleExpression)
            )
          }
          return ruleType === RuleType.udoconditional && ruleExpression && eval(ruleExpression)
        }

        const isWindowCondtional = ruleType === RuleType.conditional && ruleExpression && eval(ruleExpression)
        const isUdoConditional = getUdoResult()
        if (isWindowCondtional || isUdoConditional) {
          result = (
            <RuleTypeRenderer
              ruleId={ruleId}
              resultsTrue={resultsTrue}
              resultsFalse={resultsFalse}
              ruleType={ruleType}
              condition={condition}
              ruleExpression={ruleExpression}
              isInEditor={isEditor}
              componentTypeRenderer={componentTypeRenderer}
              compName={props?.compName}
            />
          )
          break
        }
      }
      return result ?? getDefaultBlock()
    }
  }, [conditionals, isInEditor, index])

  const getUdoElseBlock = () => {
    if (conditionals.length === 0 && (resultsTrue || resultsFalse)) {
      return (
        <RuleTypeRenderer
          key={index}
          ruleId={ruleId}
          resultsTrue={resultsTrue}
          resultsFalse={resultsFalse}
          ruleType={RuleType.udoconditional}
          isInEditor={isEditor}
          componentTypeRenderer={componentTypeRenderer}
          compName={props?.compName}
        />
      )
    }
  }

  const getDefaultBlock = () => {
    if (defaultblock) {
      return (
        <div id='rule-results' className='rule-results' data-testid={ruleId} key={index}>
          <RuleResultsRenderer
            key={index}
            ruleId={ruleId}
            results={defaultblock.resultsTrue}
            ruleExpression={ruleExpression}
            index={index}
            isInEditor={isEditor}
            componentTypeRenderer={componentTypeRenderer}
          />
        </div>
      )
    }
  }

  return (
    <div data-testid='react-rule-builder-conditional' id={id}>
      {getConditionals()}
      {getUdoElseBlock()}
    </div>
  )
}

export default RuleBuilderConditional
